/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";


    export interface ILoginCredentials {
        loginInfo: ILoginBindingModel;
        updatePhone: boolean;
        updatePassword: boolean;
    }

    class LoginCredentials implements ILoginCredentials {
        static serviceId: string = "loginCredentials";
        public loginInfo: ILoginBindingModel;
        public updatePhone: boolean;
        public updatePassword: boolean;
        
    }

    angular.module("app").factory(LoginCredentials.serviceId, [() => new LoginCredentials()]);

}